var __TEMP__ = require('./_createCaseFirst.js');var createCaseFirst = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = upperFirst;
